const types = {
  CREATE_NEW_COLUMN: 'CREATE_NEW_COLUMN',
  CREATE_NEW_COLUMN_SUCCESS: 'CREATE_NEW_COLUMN_SUCCESS',
  CREATE_NEW_COLUMN_FAILED: 'CREATE_NEW_COLUMN_FAILED',
  GET_BOARD_COLUMNS: 'GET_BOARD_COLUMNS',
  GET_BOARD_COLUMNS_SUCCESS: 'GET_BOARD_COLUMNS_SUCCESS',
  GET_BOARD_COLUMNS_FAILED: 'GET_BOARD_COLUMNS_FAILED',
  DELETE_COLUMN: 'DELETE_COLUMN',
  DELETE_COLUMN_SUCCESS: 'DELETE_COLUMN_SUCCESS',
  DELETE_COLUMN_FAILED: 'DELETE_COLUMN_FAILED',
  UPDATE_COLUMN: 'UPDATE_COLUMN',
  UPDATE_COLUMN_SUCCESS: 'UPDATE_COLUMN_SUCCESS',
  UPDATE_COLUMN_FAILED: 'UPDATE_COLUMN_FAILED',
  CREATE_CARD: 'CREATE_CARD',
  CREATE_CARD_SUCCESS: 'CREATE_CARD_SUCCESS',
  CREATE_CARD_FAILED: 'CREATE_CARD_FAILED',
  DELETE_CARD: 'DELETE_CARD',
  DELETE_CARD_SUCCESS: 'DELETE_CARD_SUCCESS',
  DELETE_CARD_FAILED: 'DELETE_CARD_FAILED',
  UPDATE_CARD: 'UPDATE_CARD',
  UPDATE_CARD_SUCCESS: 'UPDATE_CARD_SUCCESS',
  UPDATE_CARD_FAILED: 'UPDATE_CARD_FAILED',
  COLUMN_MOVE: 'COLUMN_MOVE',
}

export default types;
